import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { RootState } from '../../../../types/common.types';

import { useSupportApi } from '../../../../api/support/useSupportApi';

import { setMessages } from '../../../../slices/programme/support/support.slice';

import SupportChat from '../../../../components/screens/programme/support/support-chat/SupportChat';

const SupportChatContainer = () => {
  const { messageOwner, messages } = useSelector(({ support }: RootState) => support);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { status, systemUserExternalReference, programmeExternalReference } = useParams();

  const [searchParams] = useSearchParams();

  const hasSubProgrammes = searchParams.get('hasSubProgrammes') === 'true';

  const { viewMessages, createMessage: createMessageRequest } = useSupportApi();

  useEffect(() => {
    viewMessages({
      programmeExternalReference: programmeExternalReference!,
      systemUserExternalReference: systemUserExternalReference!,
      page: 0,
      size: 99,
      showSpinner: true
    });

    const interval = setInterval(() => {
      viewMessages({
        programmeExternalReference: programmeExternalReference!,
        systemUserExternalReference: systemUserExternalReference!,
        page: 0,
        size: 99
      });
    }, 5000);

    return () => clearInterval(interval);
  }, [viewMessages, programmeExternalReference, systemUserExternalReference]);

  const createMessage = (text: string, onSuccess: () => void) => {
    createMessageRequest(
      {
        programmeExternalReference: programmeExternalReference!,
        systemUserExternalReference: systemUserExternalReference!,
        text
      },
      () => {
        viewMessages({
          programmeExternalReference: programmeExternalReference!,
          systemUserExternalReference: systemUserExternalReference!,
          page: 0,
          size: 99
        });
        onSuccess();
      }
    );
  };

  const navigateBack = () => {
    navigate(`/programmes/${status}/${programmeExternalReference}/support?hasSubProgrammes=${hasSubProgrammes}`);
    dispatch(setMessages([]));
  };

  return (
    <SupportChat
      status={status!}
      messageOwner={messageOwner}
      messages={messages}
      createMessage={createMessage}
      navigateBack={navigateBack}
    />
  );
};

export default SupportChatContainer;
